import { useMatches } from 'react-router';
import { DEFAULT_HANDLE, type ShellHandle } from './shellConfig';

/** The shell configuration of the deepest matched route. */
export function useShellHandle(): ShellHandle {
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i--) {
    const h = matches[i]?.handle as { shell?: ShellHandle } | undefined;
    if (h?.shell) return h.shell;
  }
  return DEFAULT_HANDLE;
}
